<template>
  <div class="container orders-page">
      <v-head></v-head>
      <v-left current="customer" active="customer"></v-left>
      <div>
          <div class="filter-dic">
              <el-input size="mini" v-model="filter.keyword" clearable @clear="search" placeholder="搜会员名、手机号" class="w240 input-with-select">
                  <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
              </el-input>
              <el-select v-model="filter.platform" placeholder="应用类型" size="mini" class="w130" @change="search" @clear="search" clearable>
                  <el-option v-for="item in $store.state.public.cfg.platform_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
              <el-select v-model="filter.app_id" placeholder="应用" size="mini" class="w200" @change="search" @clear="search" clearable>
                  <el-option v-for="item in $store.state.public.cfg.apps_options" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
              <el-date-picker size="mini" class="w240" v-model="filter.time_range" @change="search" @clear="search" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
          </div>
          <div class="list-dom">
              <el-table :data="list_data.list" v-loading="loading" style="width: 100%">
                  <el-table-column prop="id" label="UID" width="88"></el-table-column>
                  <el-table-column prop="full_name" label="姓名" width="155" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="email" label="邮箱" width="300" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="mobile" label="手机" width="144" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="country" label="国家" width="122"></el-table-column>
                  <el-table-column prop="city" label="城市" width="100"></el-table-column>
                  <el-table-column prop="last_login" label="最近登录" width="166" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="ctime" label="注册时间" width="222" show-overflow-tooltip></el-table-column>
                  <el-table-column label="操作" min-width="100" align="right">
                      <template slot-scope="scope">
                          <a class="pointer" @click="redirect('/users/detail?uid=' + scope.row.id, true)">查看</a>
                      </template>
                  </el-table-column>
              </el-table>
              <el-pagination
                  class="my-page"
                  :page-size="list_data.size"
                  background
                  layout="total, prev, pager, next"
                  @current-change="changePage"
                  :total="parseInt(list_data.total)">
              </el-pagination>        
          </div>
  
      
      
      </div>
  </div>
  </template>
  <script>
  import head from '@/pages/public/_head'
  import left from '@/pages/public/_left'
  export default {
      components:{
          'v-head':head,
          'v-left':left,
      },
      data(){
          return {
              loading:false,
              filter:{
                page: 1,
                size:20,
                keyword:'',
                platform:'',
                app_id:'',
                time_range:[],
              },
              list_data:{
                  size:20,
                  page:1,
                  total:0,
                  list:[],
              },
              pickerOptions: {
                  shortcuts: [{
                      text: '最近一周',
                      onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                      picker.$emit('pick', [start, end]);
                      }
                  }, {
                      text: '最近一个月',
                      onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                      picker.$emit('pick', [start, end]);
                      }
                  }, {
                      text: '最近三个月',
                      onClick(picker) {
                      const end = new Date();
                      const start = new Date();
                      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                      picker.$emit('pick', [start, end]);
                      }
                  }]
              },
          }
      },
      methods:{
          changePage(e){
              this.filter.page =e
              this.getList()
          },
          search(){
              this.filter.page = 1;
              this.getList()
          },
          getList(){
              this.loading = true;
              this.$http.post('/v1/pri/users/lists', this.filter)
              .then( (response) => {
                  this.loading = false;
                  var res = response.data;
                  if (res.code == 1) {
                      this.list_data = res.data
                  }
              })            
          },
      },
      mounted(){
          this.getList()
      },
  }
  </script>
  <style scoped>
  .orders-page .filter-dic{margin-bottom:14px;}
  </style>


// WEBPACK FOOTER //
// src/pages/orders/customer/Index.vue